import {
  ticketHistoryViewConstants,
  ticketHistoryViewTypes,
} from '@twiliointernal/services-common/containers/TicketHistoryView';

const DEFAULT_FIRST_PAGE = 1;
const TICKET_DETAILS_ROOT_URL = '/tickets';
const TICKETS_PER_PAGE = 20;
const VALID_SEARCH_FILTERS = [
  ticketHistoryViewConstants.filterControlNames.createdAfter,
  ticketHistoryViewConstants.filterControlNames.priority,
  ticketHistoryViewConstants.filterControlNames.product,
  ticketHistoryViewConstants.filterControlNames.statusIs,
];

const defaultQueryParams = {
  paginate: {
    perPage: TICKETS_PER_PAGE,
    page: DEFAULT_FIRST_PAGE,
  },
  scope: ticketHistoryViewTypes.TicketHistoryScopeType.requester,
};

const LOG_PREFIX = '[useTickets]';

export default {
  DEFAULT_FIRST_PAGE,
  TICKET_DETAILS_ROOT_URL,
  TICKETS_PER_PAGE,
  VALID_SEARCH_FILTERS,
  defaultQueryParams,
  LOG_PREFIX,
};
